// Handle variant changes and update the "How You'll Get Item" component
// HHC: quick view pop-ups load this script after the page has loaded, and can load it a
// second time on product pages, so start once: on DOMContentLoaded or right away.
(function(start) {
  if (window.hhcHowYoullGetItemStarted) return;
  window.hhcHowYoullGetItemStarted = true;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})(function() {
  // console.log('HOW-YOULL-GET-ITEM: DOMContentLoaded event fired');
  // Debounce initialization to avoid duplicate calls
  function debounce(func, wait) {
    let timeout;
    return function() {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, arguments), wait);
    };
  }
  const scheduleInit = debounce(() => {
    // console.log('HOW-YOULL-GET-ITEM: Running debounced initialize');
    initializeComponents();
    initializeStoreSelector();
  }, 100);
  // Initial call
  scheduleInit();
  
  // Listen for variant changes (debounced)
  document.addEventListener('variant:change', scheduleInit);
  
  // Alternative event listener for some themes
  document.querySelectorAll('[data-js-product-component]').forEach(component => {
    component.addEventListener('VARIANT_CHANGE', scheduleInit);
  });
  // Listen for Shopify VARIANT_CHANGE event on product-variants (capture phase) to re-init after AJAX updates (debounced)
  document.addEventListener('VARIANT_CHANGE', scheduleInit, true);
  // HHC: each quick view pop-up renders its own Stock & store block.
  document.addEventListener('quick-view:open', scheduleInit);

  // HHC: the widget's markup is replaced synchronously during the variant
  // update, and the debounced init above lets the Liquid placeholder text
  // paint for ~100ms (a visible flash). Filling the dates/countdowns
  // synchronously in the same task as the re-render means the placeholders
  // are overwritten before the browser paints. The debounced full init
  // (store restore + quantity fetch) still follows.
  document.addEventListener('VARIANT_CHANGE', () => {
    initializeComponents();
    // Cache-hit path is fully synchronous: restores the saved store and
    // applies the variant's known quantities (correct out-of-stock states
    // included) before the browser paints. The fetch itself is deduped via
    // quantityFetchInflight, so the debounced init that follows is cheap.
    initializeStoreSelector();
  }, true);
  
  function initializeComponents() {
    // console.log('HOW-YOULL-GET-ITEM: Initializing components');
    // Get current time in Central Time
    const now = new Date();
    const ctTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
    const currentHour = ctTime.getHours();
    const currentMinutes = ctTime.getMinutes();
    
    // console.log(`HOW-YOULL-GET-ITEM: Current CT time - ${currentHour}:${currentMinutes.toString().padStart(2, '0')}`);
    
    // Update availability for shipping, pickup, and delivery based on configured service days
    ['shipping', 'pickup', 'delivery'].forEach(type => {
      document.querySelectorAll(`[data-${type}-availability]`).forEach(element => {
        if (element.classList.contains('how-youll-get-item__availability--out-of-stock')) {
          return;
        }

        const component = element.closest('[data-how-youll-get-item]');
        if (!component) return;

        const cutoffHourMonSat = parseInt(component.getAttribute(`data-${type}-cutoff-mon-sat`) || '16');
        const cutoffHourTueFri = parseInt(component.getAttribute(`data-${type}-cutoff-tue-fri`) || '16');
        const daysOption = component.getAttribute(`data-${type}-service-days`) || 'everyday';
        let allowedDays;
        if (daysOption === 'mon-fri') {
          allowedDays = [1,2,3,4,5];
        } else if (daysOption === 'mon-sat') {
          allowedDays = [1,2,3,4,5,6];
        } else {
          allowedDays = [0,1,2,3,4,5,6];
        }

        const now = new Date();
        const ctTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
        const currentDay = ctTime.getDay();
        const currentHour = ctTime.getHours();
        const currentMinutes = ctTime.getMinutes();
        const cutoffHour = (currentDay === 1 || currentDay === 6) ? cutoffHourMonSat : cutoffHourTueFri;

        const dateElement = element.querySelector('.how-youll-get-item__date');
        if (!dateElement) return;

        let offset = 0;
        if (!(allowedDays.includes(currentDay) && currentHour < cutoffHour)) {
          offset = 1;
          while (!allowedDays.includes((currentDay + offset) % 7)) {
            offset++;
          }
        }

        if (offset === 0) {
          dateElement.textContent = 'Today';
        } else {
          const deliverDate = new Date(ctTime);
          deliverDate.setDate(ctTime.getDate() + offset);
          dateElement.textContent = deliverDate.toLocaleDateString('en-US', { weekday: 'long' });
        }

        const cutoffDate = new Date(ctTime);
        cutoffDate.setDate(ctTime.getDate() + offset);
        cutoffDate.setHours(cutoffHour, 0, 0, 0);
        const totalMinutesLeft = Math.max(0, Math.floor((cutoffDate - ctTime) / 60000));
        const hoursLeft = Math.floor(totalMinutesLeft / 60);
        const minutesLeft = totalMinutesLeft % 60;

        let countdown = element.querySelector('.how-youll-get-item__countdown');
        if (!countdown) {
          countdown = document.createElement('div');
          countdown.classList.add('how-youll-get-item__countdown');
          element.appendChild(countdown);
        }
        // Format countdown using days if >= 24 hours
        let countdownText;
        if (totalMinutesLeft >= 1440) {
          const days = Math.floor(hoursLeft / 24);
          const remHours = hoursLeft % 24;
          const dLabel = days === 1 ? 'day' : 'days';
          const hLabel = remHours === 1 ? 'hr' : 'hrs';
          const mLabel = minutesLeft === 1 ? 'min' : 'mins';
          countdownText = `Order within ${days} ${dLabel}` +
                          (remHours > 0 ? ` ${remHours} ${hLabel}` : '') +
                          (minutesLeft > 0 ? ` ${minutesLeft} ${mLabel}` : '');
        } else {
          const hLabel = hoursLeft === 1 ? 'hr' : 'hrs';
          const mLabel = minutesLeft === 1 ? 'min' : 'mins';
          countdownText = `Order within ${hoursLeft} ${hLabel} ${minutesLeft} ${mLabel}`;
        }
        countdown.textContent = countdownText;
        // Highlight urgent timers (<3 hours) for all options
        if (totalMinutesLeft < 180) {
          countdown.classList.add('how-youll-get-item__countdown--urgent');
        } else {
          countdown.classList.remove('how-youll-get-item__countdown--urgent');
        }
      });
    });
  }

  // HHC: the product page and each quick view pop-up have their own store rows and select.
  function productRoot(element) {
    return element.closest('[data-js-product-component]') || document;
  }

  // HHC: the delivery widget, or in quick view (no widget) the Stock & store block itself.
  function componentFor(select) {
    return select.closest('[data-how-youll-get-item]') ||
      productRoot(select).querySelector('[data-how-youll-get-item]') ||
      select.closest('[data-store-stock]');
  }

  // HHC: the widget re-renders with each variant; the quick view block does not, so read its form.
  function variantIdFor(component) {
    if (component.hasAttribute('data-how-youll-get-item')) return component.getAttribute('data-variant-id');
    const input = productRoot(component).querySelector('input[name="id"]');
    return input && input.value ? input.value : component.getAttribute('data-variant-id');
  }

  // HHC: per-variant quantity cache + in-flight fetch dedup. Re-visiting a
  // variant applies its known quantities synchronously (no flash, correct
  // availability before paint) while a background refetch keeps them fresh.
  const quantityCache = {};
  const quantityFetchInflight = {};

  function applyQuantities(select, quantitiesById) {
    Array.from(select.querySelectorAll('option')).forEach(option => {
      if (option.value === 'none') return;
      const name = option.getAttribute('data-name') || option.textContent;
      const quantity = quantitiesById[option.value] !== undefined ? quantitiesById[option.value] : 0;
      option.textContent = `${name} • ${quantity} in store`;
      option.setAttribute('data-quantity', quantity);
    });
  }

  /**
   * Populate store selector options with actual inventory quantities via backend API.
   */
  function populateStoreOptionQuantities(select, component) {
    const variantId = variantIdFor(component);
    const root = productRoot(select);
    if (quantityCache[variantId]) {
      applyQuantities(select, quantityCache[variantId]);
      handleStoreChange({ target: select });
    }
    if (quantityFetchInflight[variantId]) return;
    quantityFetchInflight[variantId] = true;
    // Batch all location IDs into a single request ('none' is not a location)
    const locationIds = Array.from(select.querySelectorAll('option')).map(opt => opt.value).filter(v => v !== 'none');
    fetch('https://location-inventory-fetch-rasheedsulaimans-projects.vercel.app/api/get-inventory', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ variantId, locationIds })
    })
    .then(response => response.json())
    .then(data => {
      delete quantityFetchInflight[variantId];
      // Expecting data as an array of { locationId, quantity } or a map of id->quantity
      const quantitiesById = {};
      locationIds.forEach(id => {
        let quantity = 0;
        if (Array.isArray(data)) {
          const entry = data.find(item => String(item.locationId) === id);
          if (entry && entry.quantity !== undefined) quantity = entry.quantity;
        } else if (data[id] !== undefined) {
          quantity = data[id];
        }
        quantitiesById[id] = quantity;
      });
      quantityCache[variantId] = quantitiesById;
      // HHC staleness guard: if the widget re-rendered while this fetch was in
      // flight, this select was replaced and detached. Re-resolve to the live
      // select and apply ONLY if the page still shows the variant this fetch
      // was for — that covers flipping away and back before the first fetch
      // resolves (the return flip deduped against this in-flight request and
      // is waiting on it). A different live variant has its own fetch/cache.
      let target = select;
      if (!target.isConnected) {
        const liveComponent = root.querySelector('[data-how-youll-get-item]');
        if (!liveComponent || liveComponent.getAttribute('data-variant-id') !== String(variantId)) return;
        target = root.querySelector('.how-youll-get-item__store-selector-select');
        if (!target || !target.isConnected) return;
      }
      applyQuantities(target, quantitiesById);
      // Re-evaluate pickup/delivery availability now that real quantities exist —
      // the first handleStoreChange ran before this fetch resolved.
      handleStoreChange({ target: target });
    })
    .catch(error => {
      delete quantityFetchInflight[variantId];
      console.error('HOW-YOULL-GET-ITEM: Error fetching inventory for store selector', error);
    });
  }

  /**
   * Fetch the visitor's approximate location using ipapi.co.
   */
  async function fetchUserLocation() {
    try {
      const res = await fetch('https://ipapi.co/json/');
      if (!res.ok) throw new Error('GeoIP request failed');
      const data = await res.json();
      return {
        latitude: parseFloat(data.latitude),
        longitude: parseFloat(data.longitude)
      };
    } catch (err) {
      console.error('HOW-YOULL-GET-ITEM: GeoIP fetch error', err);
      return null;
    }
  }

  function haversineDistance(lat1, lon1, lat2, lon2) {
    const toRad = d => d * Math.PI / 180;
    const R = 6371;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
              Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  function findNearestStore(select, lat, lon) {
    let nearestId = null;
    let nearestDist = Infinity;
    select.querySelectorAll('option').forEach(opt => {
      const optLat = parseFloat(opt.getAttribute('data-latitude'));
      const optLon = parseFloat(opt.getAttribute('data-longitude'));
      if (isNaN(optLat) || isNaN(optLon)) return;
      const dist = haversineDistance(lat, lon, optLat, optLon);
      if (dist < nearestDist) {
        nearestDist = dist;
        nearestId = opt.value;
      }
    });
    return nearestId ? { id: nearestId, distanceKm: nearestDist } : null;
  }

  /**
   * HHC: relocate the store <select> into the store-stock block's "Change"
   * slot (above the buy buttons) when that block is present. The widget is
   * re-rendered on every variant change, so this runs on each init: any
   * previously-moved (now stale) select is removed first, then the freshly
   * rendered one is moved in. Idempotent by design.
   */
  function relocateStoreSelect(select, component) {
    const slot = productRoot(select).querySelector('[data-store-stock-select-slot]');
    if (!slot) return;
    slot.querySelectorAll('.how-youll-get-item__store-selector-select').forEach(old => {
      if (old !== select) old.remove();
    });
    // a quick view select is rendered in the slot, so label it either way
    select.setAttribute('aria-label', 'Change store');
    if (select.parentElement !== slot) {
      slot.appendChild(select);
    }
  }

  /**
   * HHC: write the "N in stock at Store" line in the store-stock block from
   * the selected option's fetched quantity and name.
   */
  function updateStoreStockRow(option, root) {
    const row = root.querySelector('[data-store-stock-row]');
    if (!row) return;
    if (!option) {
      row.hidden = true;
      return;
    }
    const line = row.querySelector('[data-store-stock-line]');
    if (!line) return;
    const addressRow = row.querySelector('[data-store-stock-address-row]');
    const addressEl = row.querySelector('[data-store-stock-address]');
    const callEl = row.querySelector('[data-store-stock-call]');
    const mapEl = row.querySelector('[data-store-stock-map]');
    if (option.value === 'none') {
      line.textContent = row.getAttribute('data-format-no-store') || 'No store selected';
      if (addressEl) addressEl.textContent = '';
      if (callEl) callEl.hidden = true;
      if (mapEl) mapEl.hidden = true;
      if (addressRow) addressRow.hidden = true;
      row.classList.remove('store-stock__store--updating');
      row.hidden = false;
      return;
    }
    const address = option.getAttribute('data-address') || '';
    const phone = option.getAttribute('data-phone') || '';
    if (addressEl) addressEl.textContent = address;
    if (callEl) {
      if (phone) {
        callEl.href = 'tel:' + phone.replace(/[^+\d]/g, '');
        callEl.setAttribute('aria-label', 'Call ' + (option.getAttribute('data-name') || 'store') + ', ' + phone);
      }
      callEl.hidden = !phone;
    }
    if (mapEl) {
      if (address) {
        mapEl.href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(address);
        mapEl.setAttribute('aria-label', 'Map of ' + (option.getAttribute('data-name') || 'store') + ', opens in a new tab');
      }
      mapEl.hidden = !address;
    }
    if (addressRow) addressRow.hidden = !address && !phone;
    const name = option.getAttribute('data-name') || option.textContent;
    // stale-while-revalidate below only holds when the store itself is
    // unchanged; a different store must repaint immediately so the line
    // never disagrees with the address underneath it
    const storeChanged = row.getAttribute('data-store-id') !== option.value;
    row.setAttribute('data-store-id', option.value);
    const quantity = option.getAttribute('data-quantity');
    if (quantity !== null) {
      const format = row.getAttribute('data-format') || 'COUNT in stock at STORE';
      line.textContent = format.replace('COUNT', quantity).replace('STORE', name);
      row.classList.remove('store-stock__store--updating');
    } else if (line.textContent.trim() === '' || storeChanged) {
      // first paint or new store, nothing to keep — show the store name until the count loads
      line.textContent = name;
      row.classList.add('store-stock__store--updating');
    } else {
      // stale-while-revalidate: keep the previous variant's text (the store
      // itself doesn't change) and just dim it until the new count arrives
      row.classList.add('store-stock__store--updating');
    }
    row.hidden = false;
  }

  /**
   * HHC: write the "at N stores" suffix on the total-stock line, counting
   * only stores whose fetched quantity is > 0. Skipped until quantities
   * have loaded (data-quantity present on every option).
   */
  function updateStoreCount(select) {
    const el = productRoot(select).querySelector('[data-store-stock-stores]');
    if (!el) return;
    const options = Array.from(select.options).filter(o => o.value !== 'none');
    if (!options.length || options.some(o => o.getAttribute('data-quantity') === null)) return;
    const stocked = options.filter(o => parseInt(o.getAttribute('data-quantity'), 10) > 0).length;
    if (stocked === 0) {
      // When the variant itself is out of stock, extend the vendor line to
      // "Out of stock at all stores"; if there is somehow non-store (warehouse)
      // stock, show no suffix rather than a misleading one.
      const stockSpan = el.parentElement.querySelector('[data-js-variant-quantity]');
      const outOfStock = stockSpan && stockSpan.getAttribute('data-stock') === 'out-of-stock';
      el.textContent = outOfStock ? (el.getAttribute('data-format-none') || ' at all stores') : '';
      return;
    }
    const format = stocked === 1
      ? (el.getAttribute('data-format-one') || ' at COUNT store')
      : (el.getAttribute('data-format-other') || ' at COUNT stores');
    el.textContent = format.replace('COUNT', stocked);
  }

  /**
   * Initialize the store selector dropdown and restore persisted selection.
   */
  function initializeStoreSelector() {
    document.querySelectorAll('.how-youll-get-item__store-selector-select').forEach(select => {
      const component = componentFor(select);
      if (!component) return;
      relocateStoreSelect(select, component);
      // Use a global key for store selection across all products
      const storageKey = 'howYoullGetItemStore';
      // console.log(`HOW-YOULL-GET-ITEM: initializeStoreSelector, storageKey=${storageKey}`);
      // Attach change handler
      select.onchange = handleStoreChange;
      // Restore saved value or choose nearest store
      const saved = localStorage.getItem(storageKey);
      if (saved && select.querySelector(`option[value="${saved}"]`)) {
        select.value = saved;
        populateStoreOptionQuantities(select, component);
        handleStoreChange({ target: select });
      } else if (select.options.length) {
        fetchUserLocation().then(loc => {
          // HHC: preselect the nearest store only when it's within the
          // configured distance threshold (miles); otherwise — or when the
          // visitor's location is unknown — leave it at "No store" so we
          // don't claim pickup availability for a store nobody is near.
          const thresholdMiles = parseFloat(component.getAttribute('data-store-distance-threshold')) || 0;
          let chosen = 'none';
          if (loc) {
            const nearest = findNearestStore(select, loc.latitude, loc.longitude);
            if (nearest && (thresholdMiles <= 0 || nearest.distanceKm <= thresholdMiles * 1.60934)) {
              chosen = nearest.id;
            }
          }
          select.value = chosen;
          localStorage.setItem(storageKey, chosen);
          populateStoreOptionQuantities(select, component);
          handleStoreChange({ target: select });
        }).catch(() => {
          const fallback = 'none';
          select.value = fallback;
          localStorage.setItem(storageKey, fallback);
          populateStoreOptionQuantities(select, component);
          handleStoreChange({ target: select });
        });
      }
    });
  }

  /**
   * Handle a store selection change: persist and update pickup/delivery availability.
   */
  function handleStoreChange(event) {
    const select = event.target;
    // HHC staleness guard: a detached select belongs to a previous render.
    if (!select || !select.isConnected) return;
    // HHC: the select may have been relocated into the store-stock block,
    // outside the widget root — fall back to its product's widget or block.
    const component = componentFor(select);
    if (!component) return;
    // Persist globally for all products
    const storageKey = 'howYoullGetItemStore';
    const selectedValue = select.value;
    // console.log(`HOW-YOULL-GET-ITEM: handleStoreChange, selected store = ${selectedValue}`);
    localStorage.setItem(storageKey, selectedValue);
    const option = select.querySelector(`option[value="${selectedValue}"]`);
    updateStoreStockRow(option, productRoot(select));
    updateStoreCount(select);
    // HHC: "No store" selected — store-based options aren't applicable, so
    // mark the pickup/delivery cards with a "Select a store" prompt instead
    // of dates. Shipping is unaffected.
    if (selectedValue === 'none') {
      ['pickup', 'delivery'].forEach(type => {
        const block = component.querySelector(`[data-${type}-availability]`);
        if (!block) return;
        block.classList.add('how-youll-get-item__availability--out-of-stock');
        let dateEl = block.querySelector('.how-youll-get-item__date');
        if (!dateEl) {
          dateEl = document.createElement('span');
          dateEl.classList.add('how-youll-get-item__date');
          block.prepend(dateEl);
        }
        dateEl.textContent = 'Select a store';
        const countdownEl = block.querySelector('.how-youll-get-item__countdown');
        if (countdownEl) countdownEl.remove();
      });
      initializeComponents();
      return;
    }
    // HHC stale-while-revalidate: until the per-store quantity fetch has
    // resolved for this render (data-quantity present on the options), leave
    // the pickup/delivery cards in their Liquid-rendered state instead of
    // flapping them to "Out of Stock" on incomplete data (bundle parents
    // always report data-available=false until quantities arrive). The
    // post-fetch call applies the real availability in one transition.
    const quantitiesLoaded = option && option.getAttribute('data-quantity') !== null;
    if (!quantitiesLoaded) {
      initializeComponents();
      return;
    }
    // data-available comes from Liquid store_availabilities on the variant itself,
    // which is always false for bundle parents (they hold no stock at locations —
    // it derives from components). A fetched per-location quantity > 0 overrides it.
    const available = option && (option.getAttribute('data-available') === 'true' ||
      parseInt(option.getAttribute('data-quantity') || '0', 10) > 0);
    // Update pickup availability block
    const pickupBlock = component.querySelector('[data-pickup-availability]');
    if (pickupBlock) {
      if (!available) {
        pickupBlock.classList.add('how-youll-get-item__availability--out-of-stock');
        let dateEl = pickupBlock.querySelector('.how-youll-get-item__date');
        if (dateEl) dateEl.textContent = 'Out of Stock';
        else {
          dateEl = document.createElement('span');
          dateEl.classList.add('how-youll-get-item__date');
          dateEl.textContent = 'Out of Stock';
          pickupBlock.prepend(dateEl);
        }
        const countdownEl = pickupBlock.querySelector('.how-youll-get-item__countdown');
        if (countdownEl) countdownEl.remove();
      } else {
        pickupBlock.classList.remove('how-youll-get-item__availability--out-of-stock');
      }
    }
    // Update delivery availability block
    const deliveryBlock = component.querySelector('[data-delivery-availability]');
    if (deliveryBlock) {
      if (!available) {
        deliveryBlock.classList.add('how-youll-get-item__availability--out-of-stock');
        let dateEl = deliveryBlock.querySelector('.how-youll-get-item__date');
        if (dateEl) dateEl.textContent = 'Out of Stock';
        else {
          dateEl = document.createElement('span');
          dateEl.classList.add('how-youll-get-item__date');
          dateEl.textContent = 'Out of Stock';
          deliveryBlock.prepend(dateEl);
        }
        const countdownEl = deliveryBlock.querySelector('.how-youll-get-item__countdown');
        if (countdownEl) countdownEl.remove();
      } else {
        deliveryBlock.classList.remove('how-youll-get-item__availability--out-of-stock');
      }
    }
    // Recalculate timers for available options
    initializeComponents();
  }

});